/*==========================================================
HOMEPAGE RESPONSIVE SCRIPTS
==========================================================*/

$(function() {
    if ($('#uber').hasClass('homepage')) {
        //News and Events Feed
        if ($().matchHeight) {
            $('.matchHeight').matchHeight();
        }
    }
});
